<div class="fm-content-wrapper fm-lovedone-page">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="row align-items-center">
          <div class="col-sm">
            <!-- Page Title -->
            <div class="fm-page-title">
              <h2 class="fm-head-24 fm-title mb-2">Scheduled Prompts</h2>
              <p class="mb-0">Automate memory collection with gentle reminders</p>
            </div>
          </div>
          <div class="col-auto">
            <button type="button" class="fm-common-btn">
              <img src="images/icons/fm-plus-large.svg" class="fm-svg" alt="Plus Icon" />
              Create New Prompt
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 mt-4 mt-sm-0">
        <!-- Card Group Cards -->
        <div class="fm-cards-group">
          <div class="row g-3">
            <div class="col-sm-6 col-lg-4 col-xl-3">
              <div class="fm-white-column fm-card-icon fm-metric-card">
                <div class="fm-card-content">
                  <h3 class="fm-head-32 fm-title">05</h3>
                  <p class="fm-large mb-0">Total Sent</p>
                </div>
                <div class="fm-metric-icon">
                  <img src="images/icons/fm-send.svg" class="fm-svg" alt="Total Sent" />
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4 col-xl-3">
              <div class="fm-white-column fm-card-icon fm-metric-card">
                <div class="fm-card-content">
                  <h3 class="fm-head-32 fm-title">73%</h3>
                  <p class="fm-large mb-0">Responded</p>
                </div>
                <div class="fm-metric-icon">
                  <img src="images/icons/fm-check-lg.svg" class="fm-svg" alt="Responded" />
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4 col-xl-3">
              <div class="fm-white-column fm-card-icon fm-metric-card">
                <div class="fm-card-content">
                  <h3 class="fm-head-32 fm-title">01</h3>
                  <p class="fm-large mb-0">Pending</p>
                </div>
                <div class="fm-metric-icon">
                  <img src="images/icons/fm-pending.svg" class="fm-svg" alt="Pending" />
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4 col-xl-3">
              <div class="fm-white-column fm-card-icon fm-metric-card">
                <div class="fm-card-content">
                  <h3 class="fm-head-32 fm-title">02</h3>
                  <p class="fm-large mb-0">Stories Created</p>
                </div>
                <div class="fm-metric-icon">
                  <img src="images/icons/fm-book-lg.svg" class="fm-svg" alt="Stories Created" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Prompt Tracking Section Start -->
        <div class="fm-border-column fm-card-st2">
          <div class="fm-card-head">
            <h3 class="fm-head-20 fm-card-title mb-0">Prompt Configuration</h3>
          </div>
          <div class="fm-card-body">
            <div class="row g-4">
              <div class="col-sm-6 col-lg-3">
                <p class="fm-card-label">Frequency:</p>
                <p class="fm-card-content fm-large">Daily <span>(Every Day)</span></p>
              </div>
              <div class="col-sm-6 col-lg-3">
                <p class="fm-card-label">Questions Per Prompt:</p>
                <p class="fm-card-content fm-large">4 Questions</p>
              </div>
              <div class="col-sm-6 col-lg-3">
                <p class="fm-card-label">Delivery Method:</p>
                <p class="fm-card-content fm-large">Email</p>
              </div>
              <div class="col-sm-6 col-lg-3">
                <p class="fm-card-label">Started On:</p>
                <p class="fm-card-content fm-large">March 1, 2026</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Prompt Tracking Section End -->

        <!-- Prompt History Section Start -->
        <div class="fm-prompt-history-sec fm-border-column fm-card-st2 mt-4">
          <div class="fm-card-head d-flex justify-content-between align-items-center">
            <h3 class="fm-head-20 fm-card-title mb-0">Prompt History</h3>
            <ul class="fm-history-filter mb-0">
              <li>
                <button class="fm-history-filter-btn active" type="button" data-filter="all">
                  All
                </button>
              </li>
              <li>
                <button class="fm-history-filter-btn" type="button" data-filter="responded">
                  Responded
                </button>
              </li>
              <li>
                <button class="fm-history-filter-btn" type="button" data-filter="not-responded">
                  Not Responded
                </button>
              </li>
              <li>
                <button class="fm-history-filter-btn" type="button" data-filter="waiting">
                  Waiting
                </button>
              </li>
            </ul>
          </div>
          <div class="fm-card-body">
            <div class="accordion fm-accordion" id="fmPromptHistoryAccordion">
              <!-- Prompt #1 — Responded (Green) -->
              <div class="fm-history-item fm-responded" data-status="responded">
                <div class="fm-timeline-icon">
                  <span class="fm-timeline-dot">
                    <i class="bi bi-check-lg fm-timeline-icon-i"></i>
                  </span>
                </div>
                <div class="fm-history-box">
                  <div class="accordion-item fm-accordion-item">
                    <h2 class="accordion-header fm-accordion-header">
                      <button
                        class="accordion-button fm-accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#promptOne"
                        aria-expanded="true"
                        aria-controls="promptOne"
                      >
                        <div class="fm-history-content">
                          <div class="fm-history-top">
                            <div>
                              <h3 class="fm-head-20 fm-history-prompt-name">Prompt #1</h3>
                              <p class="fm-history-send-date">Sent on March 20, 2026</p>
                            </div>
                            <div class="fm-status-wrap">
                              <span class="fm-status-badge fm-status-success">
                                <i class="bi bi-camera-video-fill fm-badge-icon"></i>
                                Responded
                              </span>
                              <span class="fm-response-date">on March 21, 2026</span>
                            </div>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <div id="promptOne" class="accordion-collapse collapse show">
                      <div class="accordion-body fm-accordion-body">
                        <div class="fm-question-list">
                          <label class="fm-question-label">Questions Sent:</label>
                          <ol class="fm-question-items">
                            <li class="fm-question-item">
                              What Was Your Grandmother's Favorite Recipe?
                            </li>
                            <li class="fm-question-item">
                              Tell Me About Your Grandfather's Career
                            </li>
                          </ol>
                        </div>
                        <div class="fm-prompt-footer">
                          <a href="#" class="fm-view-story-btn">
                            View Story
                            <i class="bi bi-arrow-right"></i>
                          </a>
                          <div class="fm-avatar-group">
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="Robert King"
                              ><img src="images/profile/profile-image.png" alt="Robert King"
                            /></span>
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="Anna Adams"
                              >AA</span
                            >
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="John Smith"
                              >JS</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Prompt #2 — Not Responded (Red) -->
              <div class="fm-history-item fm-not-responded" data-status="not-responded">
                <div class="fm-timeline-icon">
                  <span class="fm-timeline-dot">
                    <i class="bi bi-x-lg fm-timeline-icon-i"></i>
                  </span>
                </div>
                <div class="fm-history-box">
                  <div class="accordion-item fm-accordion-item">
                    <h2 class="accordion-header fm-accordion-header">
                      <button
                        class="accordion-button fm-accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#promptTwo"
                        aria-expanded="true"
                        aria-controls="promptTwo"
                      >
                        <div class="fm-history-content">
                          <div class="fm-history-top">
                            <div>
                              <h3 class="fm-head-20 fm-history-prompt-name">Prompt #2</h3>
                              <p class="fm-history-send-date">Sent on March 21, 2026</p>
                            </div>
                            <span class="fm-status-badge fm-status-danger">
                              <i class="bi bi-camera-video-fill fm-badge-icon"></i>
                              Not Responded
                            </span>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <div id="promptTwo" class="accordion-collapse collapse show">
                      <div class="accordion-body fm-accordion-body">
                        <div class="fm-question-list">
                          <label class="fm-question-label">Questions Sent:</label>
                          <ol class="fm-question-items">
                            <li class="fm-question-item">
                              What Was Your Grandmother's Favorite Recipe?
                            </li>
                            <li class="fm-question-item">
                              Tell Me About Your Grandfather's Career
                            </li>
                            <li class="fm-question-item">
                              What Childhood Memory Stands Out the Most?
                            </li>
                          </ol>
                        </div>
                        <div class="fm-prompt-footer">
                          <div class="fm-avatar-group">
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="Robert King"
                              ><img src="images/profile/profile-image.png" alt="Robert King"
                            /></span>
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="Emily Clark"
                              >EC</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Prompt #3 — Not Responded (Red) -->
              <div class="fm-history-item fm-not-responded" data-status="not-responded">
                <div class="fm-timeline-icon">
                  <span class="fm-timeline-dot">
                    <i class="bi bi-x-lg fm-timeline-icon-i"></i>
                  </span>
                </div>
                <div class="fm-history-box">
                  <div class="accordion-item fm-accordion-item">
                    <h2 class="accordion-header fm-accordion-header">
                      <button
                        class="accordion-button fm-accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#promptThree"
                        aria-expanded="true"
                        aria-controls="promptThree"
                      >
                        <div class="fm-history-content">
                          <div class="fm-history-top">
                            <div>
                              <h3 class="fm-head-20 fm-history-prompt-name">Prompt #3</h3>
                              <p class="fm-history-send-date">Sent on March 22, 2026</p>
                            </div>
                            <span class="fm-status-badge fm-status-danger">
                              <i class="bi bi-camera-video-fill fm-badge-icon"></i>
                              Not Responded
                            </span>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <div id="promptThree" class="accordion-collapse collapse show">
                      <div class="accordion-body fm-accordion-body">
                        <div class="fm-question-list">
                          <label class="fm-question-label">Questions Sent:</label>
                          <ol class="fm-question-items">
                            <li class="fm-question-item">Describe Your First Day at Work</li>
                            <li class="fm-question-item">
                              What Values Did Your Parents Teach You?
                            </li>
                          </ol>
                        </div>
                        <div class="fm-prompt-footer">
                          <div class="fm-avatar-group">
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="Anna Adams"
                              >AA</span
                            >
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="Robert King"
                              ><img src="images/profile/profile-image.png" alt="Robert King"
                            /></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Prompt #4 — Responded (Green) -->
              <div class="fm-history-item fm-responded" data-status="responded">
                <div class="fm-timeline-icon">
                  <span class="fm-timeline-dot">
                    <i class="bi bi-check-lg fm-timeline-icon-i"></i>
                  </span>
                </div>
                <div class="fm-history-box">
                  <div class="accordion-item fm-accordion-item">
                    <h2 class="accordion-header fm-accordion-header">
                      <button
                        class="accordion-button fm-accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#promptFour"
                        aria-expanded="true"
                        aria-controls="promptFour"
                      >
                        <div class="fm-history-content">
                          <div class="fm-history-top">
                            <div>
                              <h3 class="fm-head-20 fm-history-prompt-name">Prompt #4</h3>
                              <p class="fm-history-send-date">Sent on March 23, 2026</p>
                            </div>
                            <div class="fm-status-wrap">
                              <span class="fm-status-badge fm-status-success">
                                <i class="bi bi-camera-video-fill fm-badge-icon"></i>
                                Responded
                              </span>
                              <span class="fm-response-date">on March 24, 2026</span>
                            </div>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <div id="promptFour" class="accordion-collapse collapse show">
                      <div class="accordion-body fm-accordion-body">
                        <div class="fm-question-list">
                          <label class="fm-question-label">Questions Sent:</label>
                          <ol class="fm-question-items">
                            <li class="fm-question-item">What Was Your Proudest Moment?</li>
                            <li class="fm-question-item">
                              Tell Me About a Place That Feels Like Home
                            </li>
                          </ol>
                        </div>
                        <div class="fm-prompt-footer">
                          <a href="#" class="fm-view-story-btn">
                            View Story
                            <i class="bi bi-arrow-right"></i>
                          </a>
                          <div class="fm-avatar-group">
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="Robert King"
                              >RK</span
                            >
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="Anna Adams"
                              ><img src="images/profile/profile-image.png" alt="Anna Adams"
                            /></span>
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="Emily Clark"
                              >EC</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Prompt #5 — Waiting (Yellow) -->
              <div class="fm-history-item fm-waiting" data-status="waiting">
                <div class="fm-timeline-icon">
                  <span class="fm-timeline-dot">
                    <i class="bi bi-hourglass-split fm-timeline-icon-i"></i>
                  </span>
                </div>
                <div class="fm-history-box">
                  <div class="accordion-item fm-accordion-item">
                    <h2 class="accordion-header fm-accordion-header">
                      <button
                        class="accordion-button fm-accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#promptFive"
                        aria-expanded="true"
                        aria-controls="promptFive"
                      >
                        <div class="fm-history-content">
                          <div class="fm-history-top">
                            <div>
                              <h3 class="fm-head-20 fm-history-prompt-name">Prompt #5</h3>
                              <p class="fm-history-send-date">Sent on March 24, 2026</p>
                            </div>
                            <span class="fm-status-badge fm-status-warning">
                              <i class="bi bi-hourglass-split fm-badge-icon"></i>
                              Waiting Response
                            </span>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <div id="promptFive" class="accordion-collapse collapse show">
                      <div class="accordion-body fm-accordion-body">
                        <div class="fm-question-list">
                          <label class="fm-question-label">Questions Sent:</label>
                          <ol class="fm-question-items">
                            <li class="fm-question-item">
                              What Was Your Grandmother's Favorite Recipe?
                            </li>
                            <li class="fm-question-item">
                              Tell Me About Your Grandfather's Career
                            </li>
                          </ol>
                        </div>
                        <div class="fm-prompt-footer">
                          <a href="#" class="fm-record-response-btn">
                            <i class="bi bi-mic-fill"></i>
                            Record a Response
                          </a>
                          <div class="fm-avatar-group">
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="Robert King"
                              ><img src="images/profile/profile-image.png" alt="Robert King"
                            /></span>
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="Anna Adams"
                              >AA</span
                            >
                            <span
                              class="fm-avatar"
                              data-bs-toggle="tooltip"
                              data-bs-custom-class="fm-history-tooltip"
                              data-bs-placement="top"
                              title="John Smith"
                              >JS</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Prompt History Section End -->
      </div>
    </div>
  </div>
</div>
